import { render, staticRenderFns } from "./Ucontainer.vue?vue&type=template&id=8c9b3bfe&scoped=true"
import script from "./Ucontainer.vue?vue&type=script&lang=js"
export * from "./Ucontainer.vue?vue&type=script&lang=js"
import style0 from "./Ucontainer.vue?vue&type=style&index=0&id=8c9b3bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9b3bfe",
  null
  
)

export default component.exports